import { useEffect, useMemo, useState } from 'react';
import HolidaysCalendar from './HolidaysCalendar';

export default function Holidays({ holidays, locale }) {
  const items = useMemo(() => [...holidays].sort((a, b) => a.id - b.id), [holidays]);
  const [currentIndex, setCurrentIndex] = useState(null);

  useEffect(() => {
    if (items.length) {
      setCurrentIndex(items.length - 1);
    } else {
      setCurrentIndex(null);
    }
  }, [items]);

  const calendarItem = currentIndex !== null ? items[currentIndex] : null;
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex !== null && currentIndex < items.length - 1;

  const handlePrevious = () => {
    if (hasPrevious) setCurrentIndex((index) => index - 1);
  };

  const handleNext = () => {
    if (hasNext) setCurrentIndex((index) => index + 1);
  };

  return (
    <section className="w-full">
      {calendarItem && (
        <HolidaysCalendar
          calendarItem={calendarItem}
          locale={locale}
          onPrevious={handlePrevious}
          onNext={handleNext}
          hasPrevious={hasPrevious}
          hasNext={hasNext}
          position={currentIndex + 1}
          total={items.length}
        />
      )}
    </section>
  );
}
